import { useTranslations } from "../../contexts/Translation";
import { useState } from "react";
import { IconButton } from "../Button/Button";
import { Copy } from "../Icons";
import styles from "./CopyValue.module.css";

type CopyValueProps = {
  value: string;
  variant?: "text" | "input" | "compact";
  testId?: string;
  label?: string;
};

const CopyValue = ({ value, variant = "input", testId, label }: CopyValueProps) => {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);
  const t = useTranslations("misc");

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setError(false);
    } catch {
      setError(true);
      setCopied(false);
    }
  };

  return (
    <div className={styles.container} data-testid={testId}>
      {variant === "compact" ? null : variant === "input" ? (
        <input className={styles.input} aria-label={label} data-testid={testId ? `${testId}-input` : undefined} type='text' value={value} readOnly />
      ) : (
        <span className={styles.text} data-testid={testId ? `${testId}-value` : undefined}>{value}</span>
      )}
      <IconButton onClick={() => copyToClipboard(value)} testId={testId ? `${testId}-copy-button` : undefined} title={t("copy")}>
        <Copy height={variant === "input" ? "30px" : "20px"} width={variant === "input" ? "30px" : "20px"} />
      </IconButton>
      {copied && <span className={styles.message} data-testid={testId ? `${testId}-status` : undefined}>{t("copiedToClipboard")}</span>}
      {error && <span className={styles.message} data-testid={testId ? `${testId}-status` : undefined}>{t("errorCopying")}</span>}
    </div>
  );
};

export default CopyValue;
